<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Notifications Template' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <h3 class="header-text font-weight-bold">Daftar Notifikasi</h3>

        <v-card>
            <v-card-title>
                Notifikasi
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    @click="createNotifikasi()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Notifikasi
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="notifications"
                :headers="headers"
                :hasAction="false"
                :has-custom-pagination="false"
                :key="tableKey"
                :custom-pagination-total-items="notifications.length"
                :custom-pagination-per-page="10"
                :custom-pagination-current-page="1"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editNotifikasi()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import NotificationsTemplateService from "@/modules/notifications_template/services/notifications_template.js";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: null,
            search: null,
            tableKey: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            notifications: [],
            headers: [
                { text: "No.", value: "no", width: 60 },
                { text: "Title", value: "title", width: 400 },
                { text: "Service", value: "service", width: 150 },
                { text: "Feature", value: "feature", width: 150 },
            ],
            headersKey: ["title", "service", "feature"],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData: function () {
            var context = this;
            this.notifications = [];

            NotificationsTemplateService.getListTemplates((result) => {
                if (result.success) {
                    result.data.forEach(function (notification, index) {
                        var row = {
                            no: index,
                            id: notification.id,
                            title: notification.title,
                            service: notification.service,
                            feature: notification.feature,
                        };

                        context.notifications.push(row);
                        context.notifications = _.orderBy(
                            context.notifications,
                            "id",
                            "desc",
                        );
                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        createNotifikasi: function () {
            this.$router.push({ path: "/notifications-template-form" });
        },

        editNotifikasi: function () {
            var context = this;
            context.isLoading = true;
            console.log(this.selectedRow);
            var notificationId = this.selectedRow.id;
            context.$store.commit("notification_init", this.selectedRow.datas);
            context.$router.push({
                path: "/notifications-template-form",
                query: { id: notificationId },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// NotificationsTemplate.vue?78307e40